import { BaseModel } from './BaseModel';

export class Video extends BaseModel {
  id: string | null = null;
  url = '';
  path = '';
  duration = 0;
  storage = 'local';
}
